import { atom } from "recoil";

import { SupportedLanguage } from "../../models";

export const appLanguageAtom = atom<SupportedLanguage>({
  key: "appLanguageAtom",
  default: "en",
});
